import React from 'react';

export default function Features() {
  return (
    <section className="features">
      <div className="feature">
        <h4>🛒 Shop online</h4>
        <p>Explore our full catalog from anywhere. Fast, secure, and easy ordering — all at your fingertips.</p>
      </div>
      <div className="feature">
        <h4>🚚 Free shipping</h4>
        <p>Get free delivery on orders over $99. No hidden fees, just quality service to your door.</p>
      </div>
      <div className="feature">
        <h4>↩ Return policy</h4>
        <p>30-day hassle-free returns. If it doesn't fit — return it with ease.</p>
      </div>
      <div className="feature">
        <h4>💳 Payment</h4>
        <p>Secure payment methods you can trust. Pay with Visa, MasterCard, Apple Pay and more.</p>
      </div>
    </section>
  );
}